angular.module('MyHippoProducer.Services').factory('AnalyticsService', function (AmplitudeService) {
    const trackEvent = (eventName, properties) => {
        AmplitudeService.trackEvent(eventName, properties);
    };

    const setUserId = (value) => {
        AmplitudeService.setUserId(value);
    };

    const identify = (value) => {
        AmplitudeService.identify(value);
    };

    const addUserProperties = (properties) => {
        AmplitudeService.addUserProperties(properties);
    };

    const resetIdentity = () => {
        AmplitudeService.resetIdentity();
    };

    const setGroup = (groupType, groupName) => {
        AmplitudeService.setGroup(groupType, groupName);
    };

    const setOptOut = (optOut) => {
        AmplitudeService.setOptOut(optOut);
    };

    const groupIdentify = (groupType, groupName, properties) => {
        AmplitudeService.groupIdentify(groupType, groupName, properties);
    };

    return {
        trackEvent,
        setUserId,
        identify,
        addUserProperties,
        resetIdentity,
        setGroup,
        setOptOut,
        groupIdentify,
    };
});
